export default __webpack_public_path__ + "static/media/cpv_18_clothes.3aefb764.svg";